import React from 'react';

class HomeCamera extends React.Component {
  render() {
    return (
      <svg
        width={80}
        height={80}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#b)" clipPath="url(#a)">
          <path
            d="m56.888 71.084-8.696-1.338a3.757 3.757 0 0 1-3.186-3.712V51.712c0-5.694 2.744-10.918 7.098-14.588 4.082-3.44 6.676-8.584 6.676-14.342 0-10.62-8.812-19.18-19.524-18.768-9.708.374-17.718 8.44-18.032 18.15-.196 6.096 2.516 11.556 6.854 15.116 4.24 3.48 6.91 8.504 6.91 13.988v14.766a3.755 3.755 0 0 1-3.186 3.712l-8.694 1.338c-2.17.334-4.042.996-5.024 2.96H61.91c-.982-1.964-2.854-2.626-5.024-2.96h.002Z"
            fill="#F7F4F1"
          />
          <path
            d="M62.712 73.875V73.823a.592.592 0 0 0-.014-.132v-.014a.95.95 0 0 0-.056-.164l-.012-.028c-1.206-2.414-3.518-3.07-5.618-3.392l-8.696-1.338a2.942 2.942 0 0 1-2.508-2.922V51.51c0-5.232 2.484-10.326 6.814-13.976a19.522 19.522 0 0 0 6.96-14.952c0-5.374-2.132-10.386-6.006-14.112-3.87-3.726-8.968-5.662-14.348-5.456-4.898.188-9.542 2.252-13.076 5.81-3.534 3.558-5.566 8.214-5.724 13.114-.198 6.126 2.408 11.872 7.146 15.76 4.206 3.452 6.618 8.326 6.618 13.37v14.766a2.94 2.94 0 0 1-2.508 2.922l-8.694 1.338c-2.102.324-4.412.98-5.618 3.392l-.012.03-.014.034a.72.72 0 0 0-.04.132v.008a.646.646 0 0 0-.014.138v.056c.024 2.132 1.904 2.188 3.28 2.226l14.942.426a159.516 159.516 0 0 0 8.98 0l14.942-.426c1.376-.04 3.258-.094 3.28-2.228l-.004-.008ZM28.588 36.459c-4.352-3.572-6.742-8.846-6.562-14.472.144-4.494 2.012-8.768 5.26-12.038 3.248-3.27 7.51-5.166 12.002-5.338 4.944-.192 9.622 1.588 13.178 5.01 3.556 3.422 5.516 8.024 5.516 12.96 0 5.302-2.33 10.306-6.39 13.73-3.282 2.766-5.582 6.308-6.67 10.138h-9.748c-1.028-3.798-3.304-7.296-6.584-9.988l-.002-.002ZM23.234 71.67l8.694-1.338a4.532 4.532 0 0 0 3.864-4.504V51.063c0-1.028-.092-2.048-.268-3.054h9.024c-.222 1.15-.34 2.32-.34 3.496v14.322a4.53 4.53 0 0 0 3.864 4.504l8.696 1.338c1.66.256 2.786.676 3.558 1.368H19.674c.772-.692 1.898-1.114 3.56-1.368v.002Z"
            fill="#83827F"
          />
          <path
            d="M40 10.26c-6.919 0-12.523 5.608-12.523 12.522 0 6.914 5.604 12.522 12.522 12.522S52.522 29.7 52.522 22.782 46.914 10.26 39.999 10.26Zm0 18.392a5.867 5.867 0 0 1-5.87-5.87 5.87 5.87 0 1 1 5.87 5.87Z"
            fill="url(#c)"
          />
          <path
            d="M40 16.914a5.87 5.87 0 1 0 0 11.74 5.87 5.87 0 0 0 0-11.74Zm0 9c-1.73 0-3.13-1.4-3.13-3.13s1.4-3.13 3.13-3.13a3.13 3.13 0 0 1 0 6.26Z"
            fill="#fff"
          />
          <path
            d="M40 25.912a3.13 3.13 0 1 0 0-6.26 3.13 3.13 0 0 0 0 6.26Z"
            fill="url(#d)"
          />
        </g>
        <defs>
          <linearGradient
            id="c"
            x1={31}
            y1={12.5}
            x2={48}
            y2={32}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset={1} stopColor="#00A872" />
          </linearGradient>
          <linearGradient
            id="d"
            x1={37.751}
            y1={20.212}
            x2={42}
            y2={25.086}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset={1} stopColor="#00A872" />
          </linearGradient>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h80v80H0z" />
          </clipPath>
          <filter
            id="b"
            x={15.892}
            y={1.6}
            width={51.424}
            height={79.601}
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity={0} result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx={1.6} dy={1.6} />
            <feGaussianBlur stdDeviation={1.5} />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
            <feBlend
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_591"
            />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_241_591"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    );
  }
}

export default HomeCamera;
